<template>
  <div class="view">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "ViewPage"
  }
</script>

<style scoped lang="scss">
  .view {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: $view-background-color;
    padding: 20px;
  }
</style>
